import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageViewerData {
    url: string;
    titulo: string;
}

@Component({
    selector: 'app-ofertas-image-viewer',
    templateUrl: './ofertas-image-viewer.component.html',
    styles: [`
        .image-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            background-color: #f8f9fa;
            max-height: 85vh;
            overflow-y: auto;
            overflow-x: hidden;
        }
        .viewer-img {
            max-width: 100%;
            max-height: 70vh;
            height: auto;
            border-radius: 8px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
            object-fit: contain;
        }
        .close-btn {
            margin-top: 20px;
            padding: 10px 25px;
            background-color: #580f2e;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s;
            flex-shrink: 0;
        }
        .close-btn:hover {
            background-color: #7a1540;
        }
        h3 {
            color: #580f2e;
            margin-bottom: 20px;
            text-align: center;
            flex-shrink: 0;
        }
    `]
})
export class OfertasImageViewerComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<OfertasImageViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageViewerData
    ) {}

    ngOnInit(): void {}

    close(): void {
        this.dialogRef.close();
    }
}
